module.exports = __webpack_public_path__ + "static/img/icon1.971cd95e.png";